import { FormGroup, Image, Progress } from '@starsoft/common/components';
import { RestrictionDetailsModalRestrictionsDetailsRendererCoinValueItemProps } from './props';
import styles from './styles.module.scss';
import { WalletService } from '@starsoft/common/services';
import { getMoneyOrAmount } from '@starsoft/common/utils';
import useTranslation from 'next-translate/useTranslation';

export default function RestrictionDetailsModalRestrictionsDetailsRendererCoinValueItem({
  restriction,
  userRestriction,
}: RestrictionDetailsModalRestrictionsDetailsRendererCoinValueItemProps) {
  const { t } = useTranslation('common');

  return (
    <FormGroup
      className={styles.container}
      label={t('restriction_progress_label')}
    >
      <div className={styles.container__row}>
        <div className={styles.container__row__image}>
          <Image
            alt={userRestriction?.restriction?.coin?.name}
            width={24}
            height={24}
            className={styles.container__row__image__image}
            src={`${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/coins/rounded/${
              userRestriction?.restriction?.coin?.image ?? 'brl.svg'
            }`}
          />
        </div>
        <p
          className={`${styles.container__row__label} ${styles['container__row__label--secondary']}`}
        >
          {WalletService.maskCurrency({
            amount: getMoneyOrAmount(userRestriction?.value),
            coin: userRestriction?.restriction?.coin,
            hideSymbol: true,
          })}
        </p>
        /
        <div className={styles.container__row__image}>
          <Image
            alt={userRestriction?.restriction?.coin?.name}
            width={24}
            height={24}
            className={styles.container__row__image__image}
            src={`${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/coins/rounded/${
              userRestriction?.restriction?.coin?.image ?? 'brl.svg'
            }`}
          />
        </div>
        <p className={styles.container__row__label}>
          {WalletService.maskCurrency({
            amount: getMoneyOrAmount(userRestriction?.restriction?.maxValue),
            coin: userRestriction?.restriction?.coin,
            hideSymbol: true,
          })}
        </p>
      </div>
      <Progress
        progress={
          (getMoneyOrAmount(userRestriction?.value) /
            getMoneyOrAmount(userRestriction?.restriction?.maxValue)) *
          100
        }
        size="medium"
      />
    </FormGroup>
  );
}
